/**
 * Privacy selector for post create flows.
 */
import React from "react";
import EntityPrivacy from "components/Entities/EntityPrivacy";
import { PrivacyLevel } from "util/userUtils";

export interface PrivacySectionProps {
  privacy: PrivacyLevel;
  onPrivacyChange: (p: PrivacyLevel) => void;
  publicOnly?: boolean;
  miniIcon?: boolean;
  showDropdown?: boolean;
  label?: string;
}

const PrivacySection: React.FC<PrivacySectionProps> = ({
  privacy,
  onPrivacyChange,
  publicOnly = false,
  miniIcon = false,
  showDropdown = true,
  label = "Privacy",
}) => (
  <div className="form-control">
    <label className="block text-sm font-semibold">{label}</label>
    <EntityPrivacy
      privacy={privacy}
      onPrivacyChange={(p) => onPrivacyChange(p as PrivacyLevel)}
      actorType="user"
      editMode={false}
      miniIcon={miniIcon}
      showDropdown={showDropdown}
      publicOnly={publicOnly}
    />
  </div>
);

export default PrivacySection;
